export enum QuestionIds {
  Welcome = 'Welcome',
  AboutYouGuided = 'AboutYouGuided',
  AboutYouD1 = 'AboutYouD1',
  AboutYouGender = 'AboutYouGender',
  AboutYouAge = 'AboutYouAge',
  AboutYouRoutine = 'AboutYouRoutine',
  AboutYouD2 = 'AboutYouD2',
  AboutYouKids = 'AboutYouKids',
  AboutYouD3 = 'AboutYouD3',
  AboutYouActivity = 'AboutYouActivity',
  AboutYouD4 = 'AboutYouD4',
  AboutYouProof1 = 'AboutYouProof1',

  RMeqQ1 = 'RMeqQ1',
  RMeqQ2 = 'RMeqQ2',
  RMeqQ3 = 'RMeqQ3',
  RMeqQ3V2 = 'RMeqQ3V2',
  RMeqQ4 = 'RMeqQ4',
  RMeqQ5 = 'RMeqQ5',
  RMeqQ6 = 'RMeqQ6',
  MeqResults = 'MeqResults',

  CreoQuizQ1 = 'CreoQuizQ1',
  CreoQuizQ2 = 'CreoQuizQ2',
  CreoQuizQ3 = 'CreoQuizQ3',
  CreoQuizQ4 = 'CreoQuizQ4',

  WellbeingQ1 = 'WellbeingQ1',
  WellbeingQ2 = 'WellbeingQ2',
  WellbeingQ3 = 'WellbeingQ3',
  WellbeingQ4 = 'WellbeingQ4',
  WellbeingQ5 = 'WellbeingQ5',
  WellbeingQ6 = 'WellbeingQ6',
  WellbeingQ7 = 'WellbeingQ7',
  WellbeingQ8 = 'WellbeingQ8',
  WellbeingQ9 = 'WellbeingQ9',
  WellbeingQ10 = 'WellbeingQ10',
  WellbeingQ11 = 'WellbeingQ11',
  WellbeingQ12 = 'WellbeingQ12',
  WellbeingQ13 = 'WellbeingQ13',
  WellbeingQ14 = 'WellbeingQ14',
  WellbeingQ15 = 'WellbeingQ15',
  WellbeingQ16 = 'WellbeingQ16',
  WellbeingQ17 = 'WellbeingQ17',
  WellbeingQ18 = 'WellbeingQ18',
  WellbeingQ19 = 'WellbeingQ19',
  WellbeingQ20 = 'WellbeingQ20',
  WellbeingQ21 = 'WellbeingQ21',
  WellbeingQ22 = 'WellbeingQ22',
  WellbeingQ23 = 'WellbeingQ23',
  WellbeingQ24 = 'WellbeingQ24',
  WellbeingQ25 = 'WellbeingQ25',
  WellbeingQ26 = 'WellbeingQ26',
  WellbeingQ27 = 'WellbeingQ27',
  WellbeingQ28 = 'WellbeingQ28',
  WellbeingQ29 = 'WellbeingQ29',
  WellbeingQ30 = 'WellbeingQ30',
  WellbeingQ31 = 'WellbeingQ31',
  WellbeingQ32 = 'WellbeingQ32',
  WellbeingQ33 = 'WellbeingQ33',
  WellbeingQ34 = 'WellbeingQ34',
  WellbeingQ35 = 'WellbeingQ35',
  WellbeingQ36 = 'WellbeingQ36',

  EduD1 = 'EduD1',
  EduQ1 = 'EduQ1',
  EduQ1Answer = 'EduQ1Answer',
  EduQ2 = 'EduQ2',
  EduQ2Answer = 'EduQ2Answer',
  EduQ3 = 'EduQ3',
  EduQ3Answer = 'EduQ3Answer',
  EduQ4 = 'EduQ4',
  EduQ4Answer = 'EduQ4Answer',
  EduQ5 = 'EduQ5',
  EduQ5Answer = 'EduQ5Answer',

  GadQ1 = 'GadQ1',
  GadQ2 = 'GadQ2',
  GadQ3 = 'GadQ3',
  GadQ4 = 'GadQ4',
  GadQ5 = 'GadQ5',
  GadQ6 = 'GadQ6',
  GadQ7 = 'GadQ7',
  GadResults = 'GadResults',

  IsiQ1 = 'IsiQ1',
  IsiQ2 = 'IsiQ2',
  IsiQ3 = 'IsiQ3',
  IsiQ4 = 'IsiQ4',
  IsiQ5 = 'IsiQ5',
  IsiD1 = 'IsiD1',

  SleepAndActivityQ1 = 'SleepAndActivityQ1',
  SleepAndActivityQ2 = 'SleepAndActivityQ2',
  SleepAndActivityD1 = 'SleepAndActivityD1',
  SleepAndActivityQ3 = 'SleepAndActivityQ3',
  SleepAndActivityProof1 = 'SleepAndActivityProof1',
  SleepAndActivityProof2 = 'SleepAndActivityProof2',
  SleepAndActivityCoffee = 'SleepAndActivityCoffee',
  SleepAndActivityDinner = 'SleepAndActivityDinner',
  SleepAndActivityAfterMidnight = 'SleepAndActivityAfterMidnight',
  SleepAndActivityLessThanEightHours = 'SleepAndActivityLessThanEightHours',
  SleepAndActivityExtraMotivation = 'SleepAndActivityExtraMotivation',
  SleepAndActivityD2 = 'SleepAndActivityD2',
  SleepAndActivityLoader = 'SleepAndActivityLoader',

  PersonalizationD1 = 'PersonalizationD1',
  PersonalizationColors1 = 'PersonalizationColors1',
  PersonalizationColors2 = 'PersonalizationColors2',
  PersonalizationColors3 = 'PersonalizationColors3',
  PersonalizationColors4 = 'PersonalizationColors4',
  PersonalizationProof1 = 'PersonalizationProof1',
  PersonalizationArtwork1 = 'PersonalizationArtwork1',
  PersonalizationArtwork2 = 'PersonalizationArtwork2',
  PersonalizationArtwork3 = 'PersonalizationArtwork3',
  PersonalizationArtwork4 = 'PersonalizationArtwork4',
  PersonalizationNarrative = 'PersonalizationNarrative',
  PersonalizationLoader = 'PersonalizationLoader',
  PersonalizationD2 = 'PersonalizationD2',
  PersonalizationD3 = 'PersonalizationD3',
  PersonalizationGoal = 'PersonalizationGoal',

  PersonalizationLength = 'PersonalizationLength',
  PersonalizationFrequency = 'PersonalizationFrequency',
  PersonalizationFeelingHoping = 'PersonalizationFeelingHoping',
  PersonalizationSounds = 'PersonalizationSounds',
  PersonalizationPlaces = 'PersonalizationPlaces',
  PersonalizationFeeling = 'PersonalizationFeeling',

  IntroSignInLoader = 'IntroSignInLoader',

  BlitzArt = 'BlitzArt',
  BlitzDaydream = 'BlitzDaydream',
  BlitzTinnitus = 'BlitzTinnitus',
  BlitzRead = 'BlitzRead',
  BlitzShiftWork = 'BlitzShiftWork',
  BlitzADHD = 'BlitzADHD',
}
